import { Star } from "lucide-react";
import { fileUrl } from "@/lib/api";

export function Avatar({ photo, name, size = "h-16 w-16", testId }) {
  const initials = (name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  if (photo) return <img src={fileUrl(photo)} alt={name} className={`${size} shrink-0 rounded-2xl object-cover`} data-testid={testId} />;
  return (
    <span className={`${size} flex shrink-0 items-center justify-center rounded-2xl bg-orange-100 font-display text-xl font-bold text-orange-700`} data-testid={testId}>
      {initials}
    </span>
  );
}

export function Rating({ avg, count }) {
  if (!count) return <span className="rounded-full bg-slate-100 px-3 py-1 text-sm font-semibold text-slate-600">Novo</span>;
  return (
    <span className="inline-flex items-center gap-1 text-base font-bold text-slate-800">
      <Star className="h-5 w-5 fill-yellow-400 text-yellow-400" /> {String(avg).replace(".", ",")}
      <span className="font-normal text-slate-500">({count})</span>
    </span>
  );
}

export function StarInput({ value, onChange }) {
  return (
    <div className="flex gap-2" role="radiogroup" aria-label="Nota">
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" onClick={() => onChange(n)} aria-label={`${n} estrela(s)`} data-testid={`review-star-${n}`}
          className="rounded-xl p-1 transition-transform active:scale-90">
          <Star className={`h-11 w-11 ${n <= value ? "fill-yellow-400 text-yellow-400" : "text-slate-300"}`} />
        </button>
      ))}
    </div>
  );
}
